var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#2B2D30",
    fillOpacity: 0.996078
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    stroke: "#2B2D30"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 32.5C45 32.8978 44.842 33.2794 44.5607 33.5607C44.2794 33.842 43.8978 34 43.5 34H34V43.5C34 43.8978 33.842 44.2794 33.5607 44.5607C33.2794 44.842 32.8978 45 32.5 45C32.1022 45 31.7206 44.842 31.4393 44.5607C31.158 44.2794 31 43.8978 31 43.5V34H21.5C21.1022 34 20.7206 33.842 20.4393 33.5607C20.158 33.2794 20 32.8978 20 32.5C20 32.1022 20.158 31.7206 20.4393 31.4393C20.7206 31.158 21.1022 31 21.5 31H31V21.5C31 21.1022 31.158 20.7206 31.4393 20.4393C31.7206 20.158 32.1022 20 32.5 20C32.8978 20 33.2794 20.158 33.5607 20.4393C33.842 20.7206 34 21.1022 34 21.5V31H43.5C43.8978 31 44.2794 31.158 44.5607 31.4393C44.842 31.7206 45 32.1022 45 32.5Z",
    fill: "#FFFFFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackAdd);
export default __webpack_public_path__ + "static/media/BlackAdd.a967eeaf0df81c110d7dcd1136e1e72b.svg";
export { ForwardRef as ReactComponent };